import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardMessage,
	CardTitle
} from "src/common/components/Card";
import { FullCardPreloader } from "src/common/components/Preloader";
import { PatientLink, usePatientIdParam } from "src/features/patient";
import { node as patientConditionForm } from "src/modules/kd/forms/patientCondition";
import { StatusHistoryTimeline } from "src/modules/ktx/status-history/StatusHistoryTimeline";
import { usePatientConditionEvents } from "src/modules/ktx/status-history/usePatientConditionEvents";
import { usePatientConditionTimelineItems } from "src/modules/ktx/status-history/usePatientConditionTimelineItems";

const messages = defineMessages({
	title: {
		id: "kd.status_history.title",
		defaultMessage: "Állapotváltozás áttekintő"
	},
	status: {
		id: "kd.status_history.status",
		defaultMessage: "Státusz"
	},
	noChanges: {
		id: "kd.status_history.no_changes",
		defaultMessage: "Nincsenek állapotváltozások"
	},
	newChange: {
		id: "kd.status_history.new_change",
		defaultMessage: "Új állapotváltozás"
	}
});

export const StatusHistory: React.FunctionComponent = () => {
	const patientId = usePatientIdParam();
	const { isLoading, events } = usePatientConditionEvents(patientId);
	const items = usePatientConditionTimelineItems(events);
	return (
		<Card>
			<CardHeader>
				<CardTitle>
					<FormattedMessage {...messages.title} />
				</CardTitle>
			</CardHeader>
			<CardContent>
				{isLoading ? (
					<FullCardPreloader />
				) : items.length === 0 ? (
					<CardMessage>
						<FormattedMessage {...messages.noChanges} />
					</CardMessage>
				) : (
					<StatusHistoryTimeline items={items} />
				)}
			</CardContent>
			<CardFooter>
				<PatientLink
					to={`/form/${patientConditionForm.id}`}
					className="button button--primary"
				>
					<FormattedMessage {...messages.newChange} />
				</PatientLink>
			</CardFooter>
		</Card>
	);
};
